import { render, staticRenderFns } from "./ProductDetailFullScreenDialog.vue?vue&type=template&id=24dc81a6&scoped=true&"
import script from "./ProductDetailFullScreenDialog.vue?vue&type=script&lang=js&"
export * from "./ProductDetailFullScreenDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailFullScreenDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductDetailFullScreenDialog.vue?vue&type=style&index=1&id=24dc81a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc81a6",
  null
  
)

export default component.exports